import { Documents } from '@/components/beneficiary/Documents'
import { Document } from '@/store/document'
import { isNoteDocument } from '@repo/shared/utils'
import { useT } from '@repo/ui/hooks'
import { useMemo } from 'react'

export function BeneficiaryNotes({
  allDocuments,
}: {
  allDocuments: Document[]
}) {
  const { t, tc } = useT({ keyPrefix: 'documents' })
  const notes = useMemo(
    () => allDocuments.filter((v) => isNoteDocument(v)),
    [allDocuments],
  )
  return (
    <Documents
      description={t('noteDescription')}
      documents={notes}
      title={tc('note', { count: 2, cfl: true })}
    />
  )
}
